<script>
    import BrandCinema from "../components/BrandCinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /**
 *
 */
    let {
        contextDresonRule,
        timelineEntryId,
        index,
        view,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        featureIndex,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let recommendations = $state(),
        headline = $state(),
        additionalClickTracking = $state(),
        tracking = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const indexParam = index ? `&index=${index}` : "";
        const viewParam = view ? `&view=${view}` : "";
        const timelineEntryIdParam = timelineEntryId ? `&timelineEntryId=${timelineEntryId}` : "";
        const parameters = `${indexParam}${timelineEntryIdParam}${viewParam}`;
        const res = await ajaxFetch(
            `/reco-core/recommendations/brand?encodedDresonRule=${contextDresonRule}${parameters}`
        );
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            recommendations,
            headline,
            featuresState,
            additionalClickTracking,
            tracking,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_brand_cinema_wrapper">
        <BrandCinema
            {headline}
            {recommendations}
            {performance}
            {cinemaInjectionContainerWidth}
            additionalCinemaClickTracking={additionalClickTracking}
            {featuresState}
            {featureIndex}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            {tracking}
            personalisedUser={hasPersonalisedRecommendations}
        />
    </div>
{/if}

<style lang="scss">
    .reco_brand_cinema_wrapper {
        max-height: 672px;
        position: relative;
    }
</style>
